import { Component, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil, filter, tap } from 'rxjs/operators';

@Component({
    selector: 'nav-bar',
    template: `
        <div *ngIf="!hide" style="border-bottom: 1px solid rgba(0, 0, 0, 0.12);">
            <span fxFlex></span>
            <search *ngIf="homeActive" fxFlex="40"></search>
            <span fxFlex="0px" fxFlex.gt-sm="100px"></span>
        </div>
    `
})
export class NavbarComponent implements OnDestroy {
    private cleanupTime = new Subject<void>();
    homeActive: boolean;
    hide: boolean;

    constructor(router: Router) {
        router.events
        .pipe(
            filter(event => event instanceof NavigationEnd),
            tap((event: NavigationEnd) => this.homeActive = event.url.startsWith('/digest')),
            takeUntil(this.cleanupTime)
        ).subscribe();
    }

    ngOnDestroy(): void {
        this.cleanupTime.next();
        this.cleanupTime.complete();
    }
}
